/* Replays the $ / jQuery calls recorded by the stand-in in snippets/jQuery_lastest.liquid.
   Loaded with defer after jQuery, the vendor plugins and the theme, so a recorded
   $('.x').slick(...) finds its plugin. Each recorded chain runs once, in page order. */
(function () {
  var q = window.__dgjq;
  window.__dgjq = null;
  if (!q || !window.jQuery || window.jQuery.__dgStub) return;
  q.forEach(function (path) {
    try {
      var cur = window.jQuery, ctx = null;
      path.forEach(function (step) {
        if ('k' in step) { ctx = cur; cur = cur[step.k]; }
        else { cur = cur.apply(ctx, step.a); ctx = null; }
      });
    } catch (e) {
      if (window.console) console.error('dg-jquery-ready: replay failed', e);
    }
  });
})();
